/**
 * Copyright IBM Corp. 2022, 2026
 */

import Person from './person'
import s from './style.module.css'

export default function People({ people }) {
	if (people?.length > 0) {
		return (
			<ul className={s.peopleBlock}>
				{people.map((person) => (
					<Person
						key={person.name}
						{...person}
						initials={!person?.photo?.url && getInitials(person.name)}
					/>
				))}
			</ul>
		)
	}
	return null
}

// Returns the first letters of the first and last names. Returns a single letter if
// one word is provided.
function getInitials(name) {
	return name
		.trim()
		.split(/ +/g)
		.filter((n, i, a) => i === 0 || i === a.length - 1) // Get first and last words of name
		.reduce((acc, name) => acc + name[0], '') // Get first letters of each word
		.toUpperCase()
}
